<div class="column">
  <div class="row">
    <div class="search">
      <mat-icon matPrefix svgIcon="search" color="accent"></mat-icon>
      <input type="search" placeholder="Search by ID, Name or City"
        class='mat-body secondary-border-element background-text-element text-input' [formControl]='search'
        list='searchDataList' #searchInput tabindex="1">
      </div>

      <div class="country-filter">
        <button mat-button [matMenuTriggerFor]="filterCountry">
          <span class='mat-body flex-center'><span class='v-middle'>{{getShownCountry()}}</span>
          <mat-icon svgIcon="dropdownMenu" class="secondary-contrast-icon"></mat-icon>
        </span>
      </button>
      <mat-menu #filterCountry="matMenu" xPosition="before">
        @for (countryID of CountriesIDs | keyvalue; track countryID) {
          <button
            (click)="setCountryFilter(countryID.value)"
          mat-menu-item>{{this.getFullCountryNameById(countryID.value)}}</button>
        }
      </mat-menu>
    </div>
    <div class="spacer"></div>

    <div class="spacer"></div>

    <form class="radios secondary-border-element primary-background-element">
      <mat-radio-group [formControl]="shopType" on>
        <mat-radio-button [value]="ShopTypesEnum.clinic"> Clinics</mat-radio-button>
        <mat-radio-button [value]="ShopTypesEnum.entOffice"> ENT Offices </mat-radio-button>
      </mat-radio-group>
    </form>
    <div class="spacer"></div>
    <form class="radios secondary-border-element primary-background-element">
      <mat-radio-group [formControl]="shopState">
        <mat-radio-button [value]="ShopStateEnum.published"> Published </mat-radio-button>
        <mat-radio-button [value]="ShopStateEnum.requested"> Requested</mat-radio-button>
      </mat-radio-group>
    </form>
    <div class="spacer"></div>

    <div [matTooltip]="getTooltipTimestampsLookUpTable().value" class="button-wrapper">
      @if ((isGenerateLookupTableLoadedSubject|async)==true) {
        <button mat-raised-button color="accent"
          [color]="isNeedToGenerateLookupTable() ? 'warn' : 'accent'" [disabled]="!isNeedToGenerateLookupTable()"
        (click)="generateZipLookupTable()">Update Zips</button>
      }
      @if ((isGenerateLookupTableLoadedSubject|async)==false) {
        <p class="lookup-table-loading warn-text-element">
        Loading...</p>
      }

    </div>
    <button mat-raised-button color="accent" [disabled]="(isOpenMapDisabledSubject | async)===true"
    (click)="openMap()">Open map</button>
    <button mat-raised-button color="accent" (click)="exportCSV()">Export CSV</button>
    <button mat-raised-button color="accent" (click)="convertCsvToJson()">XLS(X) to JSON</button>
  </div>
  <app-shop-table #homeTable></app-shop-table>
</div>


<p class="mat-small background-text-element version">Prototype:&nbsp;v{{shop_manager_version}}&nbsp;|&nbsp;Environment:
{{environmentName}}&nbsp;|&nbsp;Build datetime: {{buildDateTime|date:'MM/dd/yyyy, h:mm a'}}</p>